import { DialogComponent } from '@theme/dialog';

/** A compact announcement dialog positioned below its announcement row. */
class AnnouncementModalComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('resize', this.updatePosition);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.updatePosition);
    super.disconnectedCallback();
  }

  showDialog() {
    this.updatePosition();
    super.showDialog();
  }

  updatePosition = () => {
    const bar = this.closest('.announcement-bar');
    if (!bar) return;

    // Position the content beneath the visible announcement row before the
    // shared dialog component locks the page scroll position.
    const top = Math.min(Math.max(bar.getBoundingClientRect().bottom + 12, 12), window.innerHeight - 120);
    this.refs.dialog.style.setProperty('--announcement-modal-top', `${Math.max(12, top)}px`);
  };
}

if (!customElements.get('announcement-modal-component')) {
  customElements.define('announcement-modal-component', AnnouncementModalComponent);
}
